import { BonusStage } from 'api/common';
import { createResult, DEFAULT_RESULT, OK_BUTTON } from '../constants';
import { NotificationState } from '../types';

export const getCashBonusResult = (bonusStage: BonusStage | null) => {
  if (bonusStage === BonusStage.Canceled) {
    return createResult(
      NotificationState.CANCELLED,
      'notification.cancelled',
      OK_BUTTON
    );
  }
  if (bonusStage === BonusStage.Expired || bonusStage === BonusStage.Lost) {
    return createResult(
      NotificationState.CASH_BONUS_EXPIRED,
      'notification.cashBonusExpired',
      OK_BUTTON
    );
  }
  if (bonusStage === BonusStage.Finished) {
    return createResult(
      NotificationState.SUCCESS,
      'notification.success',
      OK_BUTTON
    );
  }
  return createResult(
    NotificationState.CASH_BONUS_CREDITED,
    'notification.cashBonusCredited',
    OK_BUTTON
  );
};

export const getFreeSpinsResult = (bonusStage: BonusStage | null) => {
  if (bonusStage === BonusStage.Canceled) {
    return createResult(
      NotificationState.CANCELLED,
      'notification.cancelled',
      OK_BUTTON
    );
  }
  if (bonusStage === BonusStage.Expired || bonusStage === BonusStage.Lost) {
    return createResult(
      NotificationState.BONUS_EXPIRED,
      'notification.expired',
      OK_BUTTON
    );
  }
  if (bonusStage === BonusStage.Finished) {
    return createResult(
      NotificationState.SUCCESS,
      'notification.success',
      OK_BUTTON
    );
  }
  if (bonusStage === BonusStage.Activated) {
    return createResult(
      NotificationState.BONUS_ACTIVATED,
      'notification.activated'
    );
  }
  return DEFAULT_RESULT;
};

export const getCpNotificationResult = (canExchangeCp: boolean) =>
  createResult(
    NotificationState.CP_CREDITED,
    'notification.cpCredited',
    canExchangeCp ? { action: 'exchangeCp' } : OK_BUTTON
  );
